import MedicalPlanDetails from "../details/medical-plan-details";
import { UserRoundIcon } from "lucide-react";
import NoPreviewCard from "../card/no-preview-card";

interface OverviewProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    medicalPlanData: any | null;
    userId: string;
    encounterId?: string;
}

export const Overview = ({ medicalPlanData, userId, encounterId }: OverviewProps) => {
    return (
        <>
            {medicalPlanData ? (
                <MedicalPlanDetails patient={medicalPlanData} userId={userId} encounterId={encounterId} />
            ) : (
                <NoPreviewCard
                    Icon={UserRoundIcon}
                    title="No Overview Available"
                    description="This patient does not have an overview of his details yet."
                    cardTitle="Patient Overview"
                />
            )}
        </>
    );
}